import React from "react";
import { Box, Grid, Button, Container } from "@mui/material";
import ServiceCard from "./Card";
import ServiceData from "../../data/ServiceData";
import { East, Rocket } from "@mui/icons-material";

function Services() {
  return (
    <Box 
      id="service" 
      sx={{ 
        padding: { xs: "40px 0", md: "80px 0" },
        background: "linear-gradient(180deg, #f5f7fa 0%, #ffffff 100%)",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: "-50%",
          right: "-20%",
          width: "60%",
          height: "100%",
          background: "radial-gradient(circle, rgba(255, 138, 0, 0.08) 0%, transparent 70%)",
          borderRadius: "50%",
        }
      }}
    >
      <Container maxWidth="xl">
        <Grid
          container
          direction="column"
          sx={{
            position: "relative",
            zIndex: 1,
          }}
        >
          {/* Header Section */}
          <Grid item container rowSpacing={3} sx={{ marginBottom: "60px" }}>
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  marginBottom: "16px",
                }}
              >
                <Box
                  sx={{
                    width: { xs: "60px", md: "80px" },
                    height: "4px",
                    background: "linear-gradient(90deg, #03A9F4 0%, #0277BD 100%)",
                    borderRadius: "2px",
                  }}
                />
                <Rocket sx={{ color: "#0277BD", fontSize: "32px" }} />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                className="fade-in-up"
                sx={{
                  fontFamily: "Montserrat, Arial",
                  textTransform: "uppercase",
                  textAlign: "left",
                  letterSpacing: "0.05em",
                  background: "linear-gradient(135deg, #03A9F4 0%, #0277BD 50%, #025D9E 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  fontSize: { xs: "32px", md: "52px" },
                  fontWeight: 900,
                  lineHeight: 1.2,
                  marginBottom: "24px",
                }}
              >
                Our Services
              </Box>
            </Grid>
            <Grid item xs={12} md={10} lg={8}>
              <Box
                className="fade-in-up"
                sx={{
                  fontFamily: "Montserrat, Arial",
                  fontSize: { xs: "15px", md: "18px" },
                  fontWeight: 500,
                  lineHeight: 1.8,
                  letterSpacing: "0.02em",
                  textAlign: "left",
                  color: "#4a5568",
                }}
              >
                We are regarded as Pakistan's top-tier, most affordable, and most reliable courier service for both domestic and international deliveries. You may depend on us to transport anything, anywhere, both inside and outside of Pakistan, whether it's a business delivery or a present for a loved one.
              </Box>
            </Grid>
          </Grid>

          {/* Service Cards */}
          <Grid 
            item 
            container 
            spacing={4}
            justifyContent="center"
            sx={{ marginBottom: "60px" }}
          >
            {ServiceData.map((data, index) => (
              <Grid 
                item 
                xs={12} 
                sm={6} 
                md={4} 
                lg={3} 
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  animation: `fadeInUp 0.8s ease-out ${index * 0.1}s backwards`,
                }}
              >
                <ServiceCard
                  title={data.title}
                  desc={data.description}
                  img_={data.img}
                />
              </Grid>
            ))}
          </Grid>

          {/* CTA Button */}
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              endIcon={<East />}
              className="modern-button"
              sx={{
                borderRadius: "8px",
                padding: "16px 40px",
                fontSize: "16px",
                fontWeight: 700,
                fontFamily: "Montserrat",
                textTransform: "capitalize",
                background: "linear-gradient(135deg, #025D9E 0%, #0277BD 100%)",
                boxShadow: "0px 16px 48px -12px rgba(2, 93, 158, 0.5)",
                color: "white",
                transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                "&:hover": {
                  background: "linear-gradient(135deg, #0277BD 0%, #03A9F4 100%)",
                  transform: "translateY(-4px)",
                  boxShadow: "0px 24px 60px -10px rgba(2, 93, 158, 0.6)",
                },
                "&:active": {
                  transform: "translateY(-2px)",
                }
              }}
            >
              Explore All Services
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Services;
